/*
 * File: /src/router/routes/inbox.js
 * Created Date: Thursday March 25th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 25th March 2021 3:00:18 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

const InboxPane = () =>
  import(
    /* webpackChunkName: "Inbox" */ 'src/components/Dashboard/Views/Inbox/InboxView.vue'
  );

export const inboxRoutes = [
  {
    path: 'inbox',
    name: 'Inbox',
    component: InboxPane
  }
];
